<template>
  <div class="success-container" v-if="show">
    <img :src="require('@/assets/images/icon_success.png')" alt="">
    <span>修改成功</span>
  </div>
</template>
<script>
export default {
  props:["title"],
  data(){
    return {
      show:true
    }
  },
  created(){
    setTimeout(()=>{
      this.show = false;
      this.$parent.success(false);
    },1500)
  }
}
</script>
<style lang="scss" scoped>
.success-container{
  z-index: 20010;
  background: #ffffff;
  @include abs-c;
  height: 100px;
  width: 100px;
  border-radius: 8px;
  box-shadow: 0px 0px 20px #cccccc;
  @include flex-d-c;
  align-items: center;
  img{
    width: 66px;
    height: 66px;
  }
  span{
    font-size: 14px;
    color: #505050;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/person/components/success.vue